import {
  updateMultiplePackagesType,
  updateMultiplePackagesSuccessType,
  updateMultiplePackagesFailureType,
} from 'actions/Packages/updateMultiplePackages';

const INITIAL_STATE = {
  isPending: false,
};

const updateMultiplePackagesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case updateMultiplePackagesType:
      return {
        isPending: true,
      };
    case updateMultiplePackagesSuccessType:
    case updateMultiplePackagesFailureType:
      return {
        isPending: false,
      };
    default:
      return state;
  }
};

export { updateMultiplePackagesReducer };
